import component from './Badge'

export default component
